import React from "react";
import { Modal, Input, Button } from "../../../components/ui";
import { isRtlLanguage, validateKey } from "./utils";

const StaticStringsModal = ({
  isOpen,
  onClose,
  modalType,
  addMode,
  activeLang,
  modalData,
  setModalData,
  keyError,
  setKeyError,
  onSave,
  isMutating,
  hasValueChanged,
}) => {
  const rtl = isRtlLanguage(activeLang);
  const modalTitle =
    modalType === "add"
      ? addMode === "single"
        ? `Add String (${activeLang})`
        : `Add JSON Strings (${activeLang})`
      : `Update String (${activeLang})`;

  const modalFooter = (
    <div className="flex justify-end gap-3">
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onSave}
        isLoading={isMutating}
        disabled={modalType === "edit" && !hasValueChanged()}
        className={modalType === "edit" && !hasValueChanged() ? "opacity-50 cursor-not-allowed" : ""}
      >
        {modalType === "add" && addMode === "json" ? "Save JSON" : modalType === "add" ? "Save" : "Update"}
      </Button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={modalTitle} footer={modalFooter} size="md">
      <div className="space-y-4">
        {modalType === "add" && addMode === "single" && (
          <>
            <Input
              label="Key"
              required
              type="text"
              placeholder="e.g. login, signup, welcome"
              value={modalData.key}
              onChange={(e) => {
                const newKey = e.target.value;
                setModalData((prev) => ({ ...prev, key: newKey }));
                setKeyError(validateKey(newKey));
              }}
              error={keyError}
              touched={!!keyError}
            />
            <Input
              label="Value"
              required
              type="text"
              placeholder={`Enter value in ${activeLang}`}
              value={modalData.value}
              dir={rtl ? "rtl" : "ltr"}
              className={rtl ? "text-right" : ""}
              onChange={(e) => setModalData((prev) => ({ ...prev, value: e.target.value }))}
            />
          </>
        )}

        {modalType === "add" && addMode === "json" && (
          <div>
            <label className="block text-sm font-medium text-secondary mb-2">
              JSON Object <span className="text-red-500">*</span>
            </label>
            <textarea
              rows={10}
              placeholder={`Paste JSON here, e.g.\n{\n  "login": "Login",\n  "signup": "Sign Up",\n  "welcome": "Welcome"\n}`}
              value={modalData.value}
              onChange={(e) => setModalData((prev) => ({ ...prev, value: e.target.value }))}
              className={`w-full px-4 py-3 rounded-lg text-sm text-secondary placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-secondary transition-colors border-gray-300 bg-grey font-mono `}
            />
          </div>
        )}

        {modalType === "edit" && (
          <>
            <Input
              label="Key"
              value={modalData.key}
              disabled
              type="text"
              className="bg-gray-50 text-gray-600 font-mono"
            />
            <Input
              label="Value"
              required
              type="text"
              placeholder={`Enter value in ${activeLang}`}
              value={modalData.value}
              dir={rtl ? "rtl" : "ltr"}
              className={rtl ? "text-right" : ""}
              onChange={(e) => setModalData((prev) => ({ ...prev, value: e.target.value }))}
            />
          </>
        )}
      </div>
    </Modal>
  );
};

export default StaticStringsModal;
